//Lib
import { Box, IconButton, Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import AccountHeader from "../AccountHeader/AccountHeader";
import { menuNavigation } from "./const";
import styles from "./Header.module.scss";
import MenuIcon from '@mui/icons-material/Menu';

const menuItems = menuNavigation.flatMap((section) => section.children).filter((item) => item.click);

const Header = () => {
  const location = useLocation();
  const local:any = localStorage.getItem('account');
  const account = local ? JSON.parse(local) : null;
  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = Boolean(anchorEl);

  const handleOpenMenu = (event: any) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  
  const handleChangeTitle = () => {
    const currentItem = menuItems.find((item) => location.pathname.match(new RegExp(item.reg)));
    return currentItem?.navItemName || "Home";
  };

  return (
    <>
      <div className={styles.Component}>
        <div className={styles.HeaderLeftContent}>
          <IconButton
            aria-label="Mở menu quản trị"
            aria-controls={openMenu ? "admin-navigation-menu" : undefined}
            aria-expanded={openMenu ? "true" : undefined}
            className={styles.MenuButton}
            onClick={handleOpenMenu}
          >
            <MenuIcon className={styles.MenuIcon} />
          </IconButton>
          <Typography>{handleChangeTitle()}</Typography>
        </div>

        <div className={styles.HeaderRightContent}>
          <AccountHeader profile={account} />
        </div>
      </div>

      <Popover
        id="admin-navigation-menu"
        open={openMenu}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box className={styles.BoxMenu} role="menu" aria-label="Điều hướng quản trị">
          {menuItems.map((element) => (
            <NavLink
              className={({ isActive }) => `${styles.Link} ${isActive ? styles.ActiveLink : ""}`}
              key={element.path}
              onClick={handleCloseMenu}
              role="menuitem"
              to={element.path}
            >
              <img src={element.icon} alt="" aria-hidden="true" />
              <span>{element.navItemName}</span>
            </NavLink>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default Header;
